const connect = {
  url: "wss://mroyppj81pv8b.messaging.solace.cloud:443",
  vpnName: "kevins-ivmr",
  userName: "solace-cloud-client",
  password: "a54s499q2b7jmce1thipn6r974",
};
export default connect;
